function enableSubmit(source, target) {
  var sbmt = document.getElementById(target);

  if (source.checked == true) {
    sbmt.disabled = false;
  } else {
    sbmt.disabled = true;
  }
}

function onSubmit(token) {
  var formData = $("#contact-form").serialize();
  $.post({
    url: 'contact',
    // the url where we want to POST
    data: formData,
    // our data object
    success: null,
    dataType: 'json' // what type of data do we expect back from the server

  }) // using the done promise callback
  .done(function (data, textStatus, jqXHR) {
    if (data.success === true) {
      //$("form#contact-form .form-control").removeClass("is-invalid").addClass("is-valid");
      $("form#contact-form .h-captcha").remove();
      $("form#contact-form :input").each(function (i) {
        $(this).removeClass("is-invalid").addClass("is-valid")[0].disabled = true;
      });
      $("form :button[type=submit]").replaceWith('<div class="alert alert-success mx-auto">' + data.message + '</div>');
    } else {
      if (data.errorCode === 1) hcaptcha.execute();
    }
  }) // using the fail promise callback
  .fail(function (jqXHR, textStatus, errorThrown) {
    if (jqXHR.status === 422) {
      //$("form#contact-form .form-control").removeClass("is-invalid").addClass("is-valid");
      $("form#contact-form :input").removeClass("is-invalid").addClass("is-valid");
      $.each(jqXHR.responseJSON.errors, function (key, value) {
        $("form#contact-form :input[name=\"" + key + "\"]").removeClass("is-valid").addClass("is-invalid");
      });
    }

    if (jqXHR.status === 419) {
      window.location.reload();
    }
  });
};

function doOnceReady() {
  document.querySelector('form#contact-form').onsubmit = (event) => {
      event.preventDefault();
      onSubmit(null);
  };

  addListeners();
}

function addListeners() {
  document.querySelectorAll('form#contact-form input').forEach((i) => {
    i.addEventListener('change', (e) => { needsValidation(e.target); });
  });

  document.querySelectorAll('form#contact-form textarea').forEach((i) => {
    i.addEventListener('change', (e) => { needsValidation(e.target); });
    i.addEventListener('keyup', (e) => { e.target.reportValidity(); });
  });

}

function needsValidation(target) {
  target.classList.remove('is-invalid', 'is-valid');
}

window.oncaptchaload = () => {

  let div = document.createElement("div");
  div.innerHTML = "Vous devez valider le captcha !";
  div.classList.add("invalid-feedback");

  document.querySelector("form#contact-form textarea[name='h-captcha-response']")
    .after(div);
}

window.onCaptchaSuccess = ($token) => {
  let h_captcha_response = document.querySelector("form#contact-form textarea[name=h-captcha-response]");
  h_captcha_response.classList.remove('is-invalid', 'is-valid');
}

if (document.readyState === 'loading') {  // Loading hasn't finished yet
  document.addEventListener('DOMContentLoaded', doOnceReady);
} else {  // `DOMContentLoaded` has already fired
  doOnceReady();
}
